import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ProductChangeCategory} from '../model/product-change';


@Pipe({
    name: 'changeCategory',
    standalone: true
})
export class ChangeCategoryPipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {
  }

  transform(value: string | null | undefined): string {
    if (value !== undefined && value !== null) {
      switch (value.toLowerCase()) {
        case ProductChangeCategory.values.functionalLowerCase:
          return this.translate.instant('change-category-pipe.functional');
        case ProductChangeCategory.values.statutoryLowerCase:
          return this.translate.instant('change-category-pipe.statutory');
        case ProductChangeCategory.values.bugfixLowerCase:
          return this.translate.instant('change-category-pipe.bugfix');
        case ProductChangeCategory.values.technicalLowerCase:
          return this.translate.instant('change-category-pipe.technical');
        default:
          return value;
      }
    }
    return '';
  }

}
